import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import VuexORM from '@vuex-orm/core';
var TypologySeparator = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(TypologySeparator, _VuexORM$Model);
  var _super = _createSuper(TypologySeparator);
  function TypologySeparator() {
    _classCallCheck(this, TypologySeparator);
    return _super.apply(this, arguments);
  }
  _createClass(TypologySeparator, [{
    key: "$save",
    value: function $save(companyId) {
      var url = this.id ? "/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typology-separators/").concat(this.id) : "/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typology-separators");
      return TypologySeparator.api().post(url, this.$toJson());
    }
  }, {
    key: "$delete",
    value: function $delete(companyId) {
      return TypologySeparator.api().delete("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typology-separators/").concat(this.id));
    }
  }], [{
    key: "entity",
    get: function get() {
      return 'typology_separators';
    }
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        construction_id: this.attr(null),
        label: this.attr(''),
        order_number: this.attr(null),
        created_at: this.attr(null),
        updated_at: this.attr(null)
      };
    }
  }]);
  return TypologySeparator;
}(VuexORM.Model);
export { TypologySeparator as default };